module.exports = __webpack_public_path__ + "static/media/option3.cf7120a7.png";